// Shared Grommet theme, applied once at the app root (see App.js).
export const theme = {
  global: {
    colors: {
      brand: '#228BE6',
      // Zombie teams play outside the bottom-score elimination (they go out
      // if they finish below the median), so they get their own undead tint.
      zombie: '#55731A',
      'zombie-light': '#F2F6DC',
    },
    font: {
      family: 'Arial',
      size: '18px',
      height: '20px',
    },
  },
  // Long-form docs need tighter headings and roomier body text than Grommet's
  // defaults, which are tuned for dashboard chrome. Setting them here keeps
  // MarkdownDoc's component map free of one-off sizing props.
  heading: {
    font: {
      family: 'Arial',
    },
    level: {
      1: { small: { size: '28px', height: '34px' } },
      2: { small: { size: '24px', height: '30px' } },
      3: { small: { size: '20px', height: '26px' } },
      4: { small: { size: '18px', height: '24px' } },
    },
    weight: 700,
  },
  paragraph: {
    medium: { size: '17px', height: '26px', maxWidth: '100%' },
    small: { size: '15px', height: '22px', maxWidth: '100%' },
  },
  table: {
    header: { border: 'bottom', pad: { horizontal: 'small', vertical: 'xsmall' } },
    body: { pad: { horizontal: 'small', vertical: 'xsmall' } },
  },
};
